import { cn } from "src/lib/utils";

export function SettingsSection({
  title,
  description,
  children,
  className,
  sectionId,
}) {
  return (
    <div
      data-settings-section={sectionId}
      className={cn(
        "relative flex flex-col gap-4 rounded-lg border p-4",
        className
      )}
    >
      <div className="flex flex-col gap-1">
        <div>{title}</div>
        {description && (
          <div className="text-muted-foreground text-sm">{description}</div>
        )}
      </div>

      {children}
    </div>
  );
}
